var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const withVariants = (variants) => (_a) => {
    var { variant = 'default' } = _a, props = __rest(_a, ["variant"]);
    if (variants[variant]) {
        return applyIconProps(variants[variant], props);
    }
    else if (variants['default']) {
        return applyIconProps(variants['default'], props);
    }
    else {
        throw new Error(`No icon variant for ${variant} nor 'default' is defined`);
    }
};
const applyIconProps = (icon, _a) => {
    var { size, color } = _a, props = __rest(_a, ["size", "color"]);
    return Object.assign({}, Object.assign(Object.assign({}, icon), { props: Object.assign(Object.assign(Object.assign({}, icon.props), { width: size, height: size, color }), props) }));
};
